module.exports = __webpack_public_path__ + "media/images/share-medium-f7829adea078ee842a60f48b8eefb270.svg";